exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-3tvHA{position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:532}.overlay-3EW_b{position:absolute;top:0;right:0;display:-webkit-box;display:-ms-flexbox;display:flex;overflow-y:auto;padding:40px;width:100%;height:100%;background-color:rgba(0,0,0,.5)}.content-3CsDR{margin:auto;padding:20px;border-radius:4px;background-color:#001a5d}.theme-dark .content-3CsDR{background-color:#001a5d}.theme-light .content-3CsDR{background-color:#fff}.closer-container-2yB5u{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;height:40px}.closer-container-2yB5u .closer-1cjjo{cursor:pointer}.modalPreloader-2up_q{margin-bottom:40px}@media(max-width: 1023px){.overlay-3EW_b{padding:140px 0 40px}}", ""]);

// exports
exports.locals = {
	"modal": "modal-3tvHA",
	"overlay": "overlay-3EW_b",
	"content": "content-3CsDR",
	"closer-container": "closer-container-2yB5u",
	"closer": "closer-1cjjo",
	"modalPreloader": "modalPreloader-2up_q"
};